"use client"
import { Component } from "@/types/types"
import { BrandMark } from "@/ui/atoms/branding/BrandMark"
import { BrandTagline } from "@/ui/atoms/branding/BrandTagline"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { Stack } from "@/ui/atoms/layout/Stack"
import { SplashLayout } from "@/ui/layouts/SplashLayout"
import { cx } from "@/utils/cx"
import { useState } from "react"

import { ForgotPasswordForm } from "./_sections/ForgotPasswordForm"
import { ForgotPasswordConfirmation } from "./_sections/ForgotPasswordConfirmation"

export const COMPONENT_NAME = "forgotPassword"

export const presets = {}

export interface Props extends Component {}

export function ForgotPasswordView({ className, testId = COMPONENT_NAME }: Props) {
  const [panel, setPanel] = useState<"form" | "confirmation">("form")
  const [email, setEmail] = useState("")

  function handleSuccess(_email: string) {
    setEmail(_email)
    setPanel("confirmation")
  }

  return (
    <SplashLayout className={className} testId={testId}>
      <Stack className={cx("gap-8 w-full max-w-[480px]")}>
        <header>
          <Stack className="gap-2 items-center">
            <TextLink href="/" testId="brandLink">
              <BrandMark className="w-[220px] h-auto" />
            </TextLink>
            <BrandTagline className="text-center" />
          </Stack>
        </header>
        <main>
          {panel === "form" && <ForgotPasswordForm onSuccess={handleSuccess} />}
          {panel === "confirmation" && <ForgotPasswordConfirmation email={email} />}
        </main>
      </Stack>
    </SplashLayout>
  )
}
